import axios from 'axios'
import {
    MessageBox,
    Message
} from 'element-ui'
// import store from '@/store'

// axios.defaults.baseURL = 'http://www.zhd.com'

let token = localStorage.getItem('JBR_SAAS_TOKEN')
// 创建axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // api的base_url
    // baseURL: 'http://www.zhd.com', // api的base_url
    timeout: 5000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
    // Do something before request is sent
    if (token) {
        config.headers['token'] = token // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    }
    config.method = 'post'
    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

let loginFlag = false

// respone拦截器
service.interceptors.response.use(
    response => {
        /**
         * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
         * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
         */
        // console.log(response)
        // return
        const res = response.data;
        if (res.code !== 1) {
            Message({
                message: res.msg,
                type: 'error',
                duration: 5 * 1000
            });
            // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
            if (res.code == -1) {
                
                location.href='./login.html'
                // if(loginFlag){
                //     return
                // }
                // loginFlag = true
                // MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
                //     confirmButtonText: '重新登录',
                //     cancelButtonText: '取消',
                //     type: 'warning'
                // }).then(() => {
                //     // store.dispatch('FedLogOut').then(() => {
                        
                //         // location.reload(); // 为了重新实例化vue-router对象 避免bug
                //         localStorage.removeItem('JBR_SAAS_TOKEN')
                //         location.href='./login.html'



                //     // });
                // })
            }
            return Promise.reject('error');
        } else {
            return response.data;
        }
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    })

export default service


// export function request(url, param, method = 'post') {
//     return new Promise((resolve, reject) => {
//         axios({
//             headers: {
//                 'Content-Type': 'application/x-www-form-urlencoded',
//                 'token': testToken
//             },
//             method: method,
//             url: url,
//             data: param,
//         }).then((res) => {
//             if (res.code == -1) {
//                 alert('登录失效')
//             } else {
//                 resolve(res)
//             }
//         }).catch(err => {
//             reject(err)
//         })
//     })
// }